const SWATCHES = [
  { name: "Black", value: "#111827" },
  { name: "Dark blue", value: "#1e3a8a" },
  { name: "Red", value: "#dc2626" },
  { name: "Orange", value: "#f97316" },
  { name: "Yellow", value: "#facc15" },
  { name: "Green", value: "#16a34a" },
  { name: "Blue", value: "#2563eb" },
  { name: "Purple", value: "#7c3aed" },
  { name: "Pink", value: "#ec4899" },
  { name: "Brown", value: "#92400e" },
  { name: "White", value: "#ffffff" },
] as const;

interface ColourPickerProps {
  value: string;
  onChange: (colour: string) => void;
}

export function ColourPicker({ value, onChange }: ColourPickerProps) {
  return (
    <fieldset className="colour-picker">
      <legend>Colour</legend>
      <div className="colour-picker__swatches">
        {SWATCHES.map((swatch) => (
          <button
            aria-label={`Use ${swatch.name.toLowerCase()}`}
            aria-pressed={value.toLowerCase() === swatch.value}
            className="colour-swatch"
            key={swatch.value}
            onClick={() => onChange(swatch.value)}
            style={{ "--swatch-colour": swatch.value } as React.CSSProperties}
            type="button"
          >
            <span aria-hidden="true" />
          </button>
        ))}
      </div>
      <label className="custom-colour">
        <span>Custom colour</span>
        <input
          aria-label="Custom colour"
          onChange={(event) => onChange(event.target.value)}
          type="color"
          value={value}
        />
      </label>
    </fieldset>
  );
}
